export default __webpack_public_path__ + "static/media/signo-de-exclamacion-big.6df0c896.svg";